"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFormatted = exports.createEmptyAddress = exports.isAddressEmpty = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var formik_1 = require("formik");
var TextField_1 = __importDefault(require("../TextField"));
var isAddressEmpty = function (address) {
    return (address.streetAddress === '' &&
        address.locality === '' &&
        address.region === '' &&
        address.postalCode === '' &&
        address.country === '' &&
        address.formatted === '');
};
exports.isAddressEmpty = isAddressEmpty;
var createEmptyAddress = function (type, primary) {
    if (primary === void 0) { primary = false; }
    return ({
        streetAddress: '',
        locality: '',
        region: '',
        postalCode: '',
        country: '',
        formatted: '',
        primary: primary,
        type: type,
    });
};
exports.createEmptyAddress = createEmptyAddress;
var join = function (values, separator) {
    return values.filter(function (v) { return v; }).join(separator);
};
var toFormatted = function (a) {
    return join([
        a.streetAddress,
        join([a.locality, join([a.region, a.postalCode, a.country], ' ')], ', '),
    ], '\n');
};
exports.toFormatted = toFormatted;
function AddressField(_a) {
    var name = _a.name, readOnly = _a.readOnly, labelExtension = _a.labelExtension;
    var t = (0, react_i18next_1.useTranslation)().t;
    var setFieldValue = (0, formik_1.useFormikContext)().setFieldValue;
    var _b = __read((0, formik_1.useField)(name), 2), fieldProps = _b[0], meta = _b[1];
    var error = meta.error;
    (0, react_1.useEffect)(function () {
        setFieldValue("".concat(name, ".formatted"), (0, exports.toFormatted)(fieldProps.value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fieldProps.value.streetAddress,
        fieldProps.value.locality,
        fieldProps.value.region,
        fieldProps.value.postalCode,
        fieldProps.value.country,
        name,
        setFieldValue,
    ]);
    if (readOnly) {
        return ((0, jsx_runtime_1.jsx)(TextField_1.default, { multiline: true, readOnly: true, name: "".concat(fieldProps.name, ".formatted"), label: "".concat(t('ds.addressField.streetAddress'), " ").concat(labelExtension || ''), error: !!error, helperText: (error || {}).value, style: { marginTop: -3 } }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", spacing: 2, flexGrow: 1 }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(fieldProps.name, ".streetAddress"), label: "".concat(t('ds.addressField.streetAddress'), " ").concat(labelExtension || ''), error: !!error, helperText: (error || {}).value }), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(fieldProps.name, ".postalCode"), label: t('ds.addressField.postalCode'), error: !!error, helperText: (error || {}).value }), (0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(fieldProps.name, ".locality"), label: t('ds.addressField.locality'), error: !!error, helperText: (error || {}).value })] })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(fieldProps.name, ".region"), label: t('ds.addressField.region'), error: !!error, helperText: (error || {}).value }), (0, jsx_runtime_1.jsx)(TextField_1.default, { name: "".concat(fieldProps.name, ".country"), label: t('ds.addressField.country'), error: !!error, helperText: (error || {}).value })] }))] })));
}
exports.default = AddressField;
AddressField.defaultProps = {
    readOnly: false,
    labelExtension: '',
};
//# sourceMappingURL=AddressField.js.map